import { NgStyle } from '@angular/common';
import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { Avatar } from 'primeng/avatar';
import { Tooltip } from 'primeng/tooltip';

import { User } from '@/interfaces';

@Component({
    selector: 'app-avatar',
    standalone: true,
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        Avatar,
        Tooltip,
        NgStyle
    ]
})
export class AvatarComponent implements OnChanges {

    @Input() user!: User;
    @Input() name!: string;
    @Input() status!: string;
    @Input() statusMap: Record<string, string> = {};
    @Input() statusColorMap: Record<string, string> = {};

    _status!: string;

    get initials(): string {
        if (!this.name) {
            return '';
        }
        const [first, last] = this.name.split(' ');
        return `${first[0]}${last ? last[0] : ''}`.toUpperCase();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['status']) {
            this._status = changes['status']?.currentValue;
            if (this._status?.includes(':')) {
                const [status, _] = this._status.split(':');
                this._status = status.trim();
            }
        }
        if (changes['user']?.currentValue && !this.name) {
            this.name = changes['user'].currentValue.username;
        }
    }

}
